import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "overlay", "checkbox", "input", "confirmButton", "hiddenInputs", "validationInput"]

  connect() {
    this.selectedIds = []
    this.selectedNames = []

    if (this.hasHiddenInputsTarget) {
      const hiddenInputs = this.hiddenInputsTarget.querySelectorAll('input[type="hidden"]')
      this.selectedIds = Array.from(hiddenInputs).map(input => input.value)
    }

    if (this.hasInputTarget && this.inputTarget.value) {
      this.selectedNames = this.inputTarget.value.split(',').map(s => s.trim()).filter(s => s.length > 0)
    }
  }

  openModal() {
    this.modalTarget.classList.add("is-open")
    this.overlayTarget.classList.add("is-open")
    document.body.style.overflow = "hidden"

    if (this.checkboxTargets.length && this.checkboxTargets[0].type === 'checkbox') {
      this.checkboxTargets.forEach(checkbox => {
        checkbox.checked = this.selectedIds.includes(checkbox.value)
      })
    }
  }

  closeModal() {
    this.modalTarget.classList.remove("is-open")
    this.overlayTarget.classList.remove("is-open")
    document.body.style.overflow = ""
  }

  closeOnOverlay(event) {
    if (event.target === this.overlayTarget) {
      this.closeModal()
    }
  }

  confirmSelection() {
    let checked = []
    if (this.checkboxTargets.length && this.checkboxTargets[0].type === 'radio') {
      checked = this.checkboxTargets.filter(cb => cb.checked)
      if (checked.length > 1) checked = [checked[0]]
    } else {
      checked = this.checkboxTargets.filter(cb => cb.checked)
    }
    this.selectedIds = checked.map(cb => cb.value)
    this.selectedNames = checked.map(cb => cb.dataset.name)
    this.inputTarget.value = this.selectedNames.join(", ")
    this.renderHiddenInputs()
    if (this.hasValidationInputTarget) {
      this.validationInputTarget.value = this.selectedIds.join(",")
      this.validationInputTarget.dispatchEvent(new Event("input", { bubbles: true }))
    }
    this.closeModal()
  }

  clearAll() {
    this.checkboxTargets.forEach(cb => { cb.checked = false })
    this.selectedIds = []
    this.selectedNames = []
    this.inputTarget.value = ""
    this.renderHiddenInputs()
    if (this.hasValidationInputTarget) {
      this.validationInputTarget.value = ""
      this.validationInputTarget.dispatchEvent(new Event("input", { bubbles: true }))
    }
  }

  renderHiddenInputs() {
    let name = ""
    if (this.inputTarget.id === "preferred-career-industry-names") {
      name = "member_profile[member_preferred_career_industries_attributes][][career_industry_id]"
    } else if (this.inputTarget.id === "preferred-job-category-names") {
      name = "member_profile[member_preferred_job_categories_attributes][][job_category_id]"
    } else if (this.inputTarget.id === "preferred-location-names") {
      name = "member_profile[member_preferred_locations_attributes][][location_id]"
    } else if (this.inputTarget.id === "preferred-employment-kind-names") {
      name = "member_profile[member_preferred_employment_kinds_attributes][][employment_kind_id]"
    } else if (this.inputTarget.id === "career-industry-names") {
      name = "member_profile[member_career_industry_attributes][career_industry_id]"
    } else if (this.inputTarget.id === "job-category-names") {
      name = "member_profile[member_job_category_attributes][job_category_id]"
    }

    if (this.checkboxTargets.length && this.checkboxTargets[0].type === 'radio') {
      this.hiddenInputsTarget.innerHTML = this.selectedIds[0] ? `<input type="hidden" name="${name}" value="${this.selectedIds[0]}">` : ''
    } else {
      this.hiddenInputsTarget.innerHTML = this.selectedIds.map(id => `<input type="hidden" name="${name}" value="${id}">`).join("")
    }
  }
}
